import moment from "moment";

const getFormatedTime = (time, customFormat = "h:mm A") => {
  return time ? moment(time, ["HH:mm:ss"]).format(customFormat) : undefined;
};

export default getFormatedTime;
